import { render } from "./PriceVoyageChoose.vue?vue&type=template&id=19a0c39d&scoped=true&ts=true"
import script from "./PriceVoyageChoose.vue?vue&type=script&lang=ts"
export * from "./PriceVoyageChoose.vue?vue&type=script&lang=ts"

import "./PriceVoyageChoose.vue?vue&type=style&index=0&id=19a0c39d&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a0c39d"]])

export default __exports__